import { Method, send } from '../../lib/MyHttp';

/**
 * 리스트
 */
export const GetList = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['name']) delete paramsT['name'];

    send(component, Method.GET, '/a/report', paramsT, success, fail);
};

/**
 * 엑셀 다운로드
 */
export const GetListDownload = (component, params, success, fail) => {
    let paramsT = { ...params };
    if (!params['name']) delete paramsT['name'];

    send(component, Method.GET, '/a/report/download', paramsT, success, fail);
};

/**
 * 정보
 */
export const Get = (component, id, success, fail) => {
    const params = {};
    send(component, Method.GET, '/a/report/' + id, params, success, fail);
};

/**
 * 등록
 */
export const Create = (component, params, success, fail) => {
    const paramsT = {
        title: params.title,
        content: params.content,
        files: params.files,
        status: params.status,
        type: params.type,
        openedAt: params.openedAt,
    };

    send(component, Method.POST, '/a/report/', paramsT, success, fail);
};

/**
 * 업데이트
 */
export const Update = (component, id, params, success, fail) => {
    const paramsT = {
        title: params.title,
        content: params.content,
        files: params.files,
        status: params.status,
        type: params.type,
        openedAt: params.openedAt,
    };

    send(component, Method.PUT, '/a/report/' + id, paramsT, success, fail);
};

/**
 * 삭제
 */
export const Delete = (component, id, success, fail) => {
    const params = {};
    send(component, Method.DELETE, '/a/report/' + id, params, success, fail);
};

/**
 * 삭제
 */
export const DeleteArray = (component, ids, success, fail) => {
    const params = { id: ids };
    send(component, Method.DELETE, '/a/report/', params, success, fail);
};
